module.exports = __webpack_public_path__ + "static/media/star.7affab3b.svg";